import { useMemo } from 'react'
import { Row } from 'antd'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import Box from './Box'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


FlipBoxes.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      heading: PropTypes.string,
      text: PropTypes.string,
      hover_text: PropTypes.string,
      hover_heading: PropTypes.string,
      cta_link: PropTypes.string,
      cta_link_caption: PropTypes.string,
    })),
  }),
}

export default function FlipBoxes({
  data = {
    items: [],
  },
}) {
  const boxes = useMemo(() => get(data, 'items', []).map((item, index) => (
    <Box key={index} {...item} zIndex={data.items.length - index} />
  )), [data.items])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Row gutter={[8, 8]} className={classNames.boxRow}>
          {boxes}
        </Row>
      </Container>
    </BlockWrapper>
  )
}
